import React, { useEffect, useRef, useState } from "react";

export function useSeo({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
      m.content = description;
    }
  }, [title, description]);
}

export function Reveal({ children, delay = 0, className = "" }) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ob = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setShow(true); ob.disconnect(); } }, { threshold: 0.12 });
    ob.observe(el);
    return () => ob.disconnect();
  }, []);
  return (
    <div ref={ref} className={className} style={{ opacity: show ? undefined : 0 }}>
      {show ? <div className="reveal" style={{ animationDelay: `${delay}ms` }}>{children}</div> : null}
    </div>
  );
}

export function Logo({ className = "h-8" }) {
  return (
    <span className="flex items-center gap-2">
      <svg viewBox="0 0 48 48" className={className} aria-hidden>
        <path d="M24 3c2 7-3 10-3 15 0 3 2 5 4 5s3-2 3-4c4 3 6 8 6 13 0 7-6 13-13 13S8 39 8 32c0-9 7-13 9-19 2-5 5-7 7-10z" fill="#F97316"/>
        <path d="M24 20c1 3-1 5-1 8 0 2 1 3 2 3s2-1 2-3c2 2 3 4 3 7 0 4-3 7-6 7s-6-3-6-7c0-4 3-6 4-9 .8-2 1.6-3 2-6z" fill="#0F1623"/>
      </svg>
      <span className="font-heading font-extrabold text-lg tracking-tight text-content">Agni <span className="text-ember">Shiksha</span></span>
    </span>
  );
}
